<template>
  <v-app-bar color="grey-darken-4" class="justify-center" :elevation="0">
    <v-app-bar-title class="flex-0-0">
      <v-img src="@/assets/logo-biodomi.png" width="220"></v-img>
    </v-app-bar-title>
    <div class="text-center position-absolute w-100">
      <span class="text-h4">ETE - LOBATO Complexo 01</span>
    </div>
  </v-app-bar>
  <v-main style="height: 100%" class="bg-grey-lighten-3">
    <router-view />
  </v-main>
</template>
